import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MenuItems, OperatingSystemGuard, SessionGuard } from '@core';

import { DataUpdateComponent } from './data-update/data-update.component';
import { OptimizationComponent } from './optimization/optimization.component';
import { PlannerComponent } from './planner.component';
import { RoutePlanningComponent } from './route-planning/route-planning.component';
import { EmployeeComponent } from './employee/employee.component';
import { RoutePlanningResolver } from './route-planning/route-planning.resolver';

const plannerChildren = MenuItems.routePlanner.children.planner.children;

const routes: Routes = [
    {
        path: `${MenuItems.routePlanner.path}/${MenuItems.routePlanner.children.planner.path}`,
        component: PlannerComponent,
        canActivate: [OperatingSystemGuard, SessionGuard],
        children: [
            {
                path: plannerChildren.employees.path,
                component: EmployeeComponent
            },
            {
                path: plannerChildren.dataUpdate.path,
                component: DataUpdateComponent
            },
            {
                path: plannerChildren.optimization.path,
                component: OptimizationComponent
            },
            {
                path: plannerChildren.routePlanning.path,
                component: RoutePlanningComponent,
                resolve: { routes: RoutePlanningResolver }
            },
            {
                path: '',
                redirectTo: plannerChildren.employees.path,
                pathMatch: 'full'
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PlannerRoutingModule {}
